// Session-only previews. Never persisted to disk, shared between accounts, or
// used instead of a fresh request. Copies prevent a mounted view mutating cache.
export function createHomeMemory({ now = Date.now, limit = 96 } = {}) {
  const entries = new Map();
  return {
    read(key) {
      const entry = entries.get(key);
      if (!entry || now() < entry.savedAt || now() - entry.savedAt >= 60_000) {
        entries.delete(key);
        return null;
      }
      return structuredClone(entry.value);
    },
    write(key, value) {
      entries.delete(key);
      entries.set(key, { savedAt: now(), value: JSON.parse(JSON.stringify(value)) });
      while (entries.size > limit) entries.delete(entries.keys().next().value);
    },
    remove(key) { entries.delete(key); },
    clear() { entries.clear(); }
  };
}

export function homeSessionKey(user, permissions = []) {
  return JSON.stringify([user?.id, Boolean(user?.isPlatformAdmin), user?.position?.name,
    [...(user?.restaurantIds || [])].sort(), [...permissions].sort()]);
}

export const homeMemory = createHomeMemory();
